import { Typography } from "@material-ui/core";
import styled from "styled-components";

export const STFormTitleTypography = styled(Typography)`
  &&& {
    font-weight: 600;
    font-size: 0.875rem;
  }
`;
